.scroll { overflow-x: auto; overscroll-behavior-x: contain; }
.key { display: flex; flex-wrap: wrap; gap: 8px 16px; margin: 0; padding: 0; list-style: none; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--text-secondary); }
.key li { display: flex; align-items: center; gap: 6px; }
.swatch { width: 10px; height: 10px; flex: none; }

@media (max-width: 639px) {
  .key { gap: 6px 12px; font-size: 8px; }
}
